const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach((item) => {
  const heading = item.querySelector('.heading');
  var contentHeight = heading.nextElementSibling.scrollHeight;

  heading.addEventListener('click', () => {
    if (heading.parentElement.classList.contains('is--open')) {
      heading.parentElement.classList.remove('is--open');
      heading.nextElementSibling.style.height = '0px';
    } else {
      heading.parentElement.classList.add('is--open');
      heading.nextElementSibling.style.height = contentHeight + 'px';
    }
  });
});
